import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './firebaseConfig'
import {auth} from './firebaseConfig'
//import '@babel/polyfill'
import 'babel-polyfill'

import './toasts/msgs'
import "./plugins/vuetify-money.js";
import "./plugins/vue-chart.js";
import "./plugins/vue-moment.js";
import "./plugins/vue-mask.js";
import "./plugins/v-viewer.js";

Vue.config.productionTip = false;

//Vue.use(VueFire)

/*new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
*/
let app;

const montarApp = () => {
  if (app) {
    return
  }

  app = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}

auth.onAuthStateChanged(() => {
  if (app) {
    return
  }

  // Restaura a sessão ANTES de montar: se o app subir com o Vuex vazio, o guard
  // de rota decide sem saber que existe usuário logado e manda para o login.
  // Monta de qualquer forma se a restauração falhar — as rotas públicas não
  // podem depender disso.
  store.dispatch('checkLoggedIn').then(montarApp, montarApp)
})

